import { executeRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

export const sapLogin = (tokens: any) => {
  const request: any = {
    apiPath: getUrl(APIEndPoints.sapLogin),
    method: 'GET',
    config: sitConfig(tokens),
    headers: getHeaders(),
  }
  return executeRequest(request)
    .then((data) => {
      isSuccessResponse(data)
      return data.data
    })
    .catch((e) => {
      throw e
    })
}
